import { render } from "./AppGaleria.vue?vue&type=template&id=44c35dff&scoped=true"
import script from "./AppGaleria.vue?vue&type=script&lang=js"
export * from "./AppGaleria.vue?vue&type=script&lang=js"

import "./AppGaleria.vue?vue&type=style&index=0&id=44c35dff&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c35dff"]])

export default __exports__